import React from "react";
import { Close } from "@dreamhub/designsystem/icons";
import { IconButton } from "@/components/ui/icon-button";
import { cn } from "@/utils/utils";

interface BaseProps {
  children: React.ReactNode;
  // "output" makes it a live region — for a strip that announces a state change.
  as?: "div" | "output";
  className?: string;
  "data-test"?: string;
}

// The close control is icon-only, so its label is what names it to a screen reader.
type DismissProps =
  | { onDismiss: () => void; dismissLabel: string }
  | { onDismiss?: never; dismissLabel?: never };

type Props = BaseProps & DismissProps;

// Full-width centred strip above a record header, with an optional close control.
const StripBanner: React.FC<Props> = ({
  children,
  as: Wrapper = "div",
  className,
  onDismiss,
  dismissLabel,
  "data-test": dataTest
}) => (
  <Wrapper
    className={cn(
      "relative flex items-center justify-center w-full min-h-12 px-12 pt-2 pb-5 bg-surface-strip-banner border-b border-widget",
      className
    )}
    data-test={dataTest}
  >
    {children}
    {onDismiss && (
      <IconButton
        variant="iconNoBg"
        size="md"
        onClick={onDismiss}
        aria-label={dismissLabel}
        className="absolute right-2"
        data-test={dataTest ? `${dataTest}-close` : undefined}
      >
        <Close />
      </IconButton>
    )}
  </Wrapper>
);

export default StripBanner;
